module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mainBar'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid home"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('tutorialPicker', {
    attrs: {
      "workbenchWrapper": _vm.workbenchWrapper
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('workbench', {
    ref: "workbench"
  })], 1)])]), _vm._v(" "), _c('modalMessage')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e3804f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1530
// module chunks = 2